import { useState, useLayoutEffect, useRef } from 'react';
import { DataGridPro, GridToolbarQuickFilter, GridToolbarExport } from '@mui/x-data-grid-pro';
import { useMyTimezone } from 'components/customer/orgs/MyOrgAPIEndpoints';
// @ts-ignore
import { UcPagination } from 'components/common/UcPagination';
// @ts-ignore
import { ensureLuxonDateUtcToTimezone } from 'lib/Formatters';
// @ts-ignore
import { useTranslation } from 'react-i18next';
import { UserEventLog } from './UserActivityLogPage.interfaces';

interface UserActivityLogGridProps {
    hideEmailColumn?: boolean,
    hideEventTypeColumn?: boolean,
    swrUserEventLogs: {
        error: any,
        isError: boolean,
        isLoading: boolean,
        isValidating: boolean,
        refetchResult: Function,
        result: UserEventLog | undefined,
        rowCount: number,
        skip: number,
        take: number,
        totalCount: number
    },
    toolbar?: boolean
}

export const UserActivityLogGrid = (props: UserActivityLogGridProps) => {
    const { t } = useTranslation();
    const timezone = useMyTimezone();

    const {
        hideEmailColumn = false,
        hideEventTypeColumn = false,
        toolbar = false
    } = props;

    let defaultDataItems = {
        columns: [
            { field: 'email', headerName: t('Email'), width: 300, flex: 1 },
            { field: 'eventTypeDisplayName', headerName: t('Event Type'), width: 200, flex: 1 },
            { field: 'eventTsUtc', headerName: t('Date & Time'), width: 200, flex: 1, valueFormatter: (params: any) => { return ensureLuxonDateUtcToTimezone(params.value, timezone).toFormat("yyyy-MM-dd t"); } },
            { field: 'eventStatusDisplayName', headerName: t('Details'), flex: 1 },
        ],
        rows: [],
        rowCount: -1,
    };
    const [dataItems, setDataItems] = useState<any>(defaultDataItems);

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        email: !hideEmailColumn,
        eventTypeDisplayName: !hideEventTypeColumn,
    });

    const defaultSelectedItem = { dataItem: {}, selectedId: 0 };
    const [selectedItem] = useState<any>(defaultSelectedItem);

    const isDataLoaded = useRef(false);

    const dataReceived = (swrResult: any) => {
        if (!swrResult?.result) return;
        
        const rows = swrResult.result.map((item: any) => ({
            ...item,
            selected: item.id === selectedItem.selectedId
        }));

        setDataItems({
            ...defaultDataItems,
            rows: rows,
            rowCount: rows.length
        });
    };

    const swrUserEventLogs = props.swrUserEventLogs;

    if (!swrUserEventLogs?.result && defaultDataItems?.rowCount !== -1) {
        setDataItems(defaultDataItems);
    }
    useLayoutEffect(() => {
        if (swrUserEventLogs?.result) {
            isDataLoaded.current = true;
            dataReceived(swrUserEventLogs);
        }
        // eslint-disable-next-line
    }, [swrUserEventLogs?.result]);

    return (
        <div
            data-cy-id={"userActivityLogGridWrapper"}
        >
            <DataGridPro
                autoHeight
                loading={!isDataLoaded.current}
                initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                    sorting: { sortModel: [{ field: 'eventTsUtc', sort: 'desc' }] },
                    filter: {
                        filterModel: {
                            items: [],
                            quickFilterValues: [''],
                            quickFilterExcludeHiddenColumns: true,
                        },
                    },
                }}
                sortingMode="client"
                paginationMode="client"
                filterMode="client"
                rowsPerPageOptions={[5, 10, 20]}
                pagination
                slots={{
                    ...(toolbar && {
                        toolbar: () => (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: 8,
                                }}
                            >
                                <GridToolbarExport />
                                <GridToolbarQuickFilter />
                            </div>
                        ),
                    }),
                    pagination: UcPagination,
                }}
                slotProps={{
                    toolbar: { showQuickFilter: true },
                }}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={setColumnVisibilityModel}
                {...dataItems}
            />
        </div>
    );
}